import {useEditor} from "@grapesjs/react";
import {observer} from "mobx-react";
import {useEffect, useState} from "react";
import {useStore} from "../../../app/store";
import {onKeyEscape} from "../../../app/editor/utils/dom";
import InputField from "../InputField";
import {CMD_SELECT_TARGET} from "../../../app/editor/plugins/global/studioPlugin";
import Button from "../../common/Button";
import {findParent} from "../../../app/editor";
import {PropertyUpdateStack} from "../../../app/store/UndoManager";

const cmpIdLabel = (cmp) => {
    return `${cmp.getName()} - #${cmp.getId()}`;
}

export default observer(function TraitHrefField({trait}) {
    const value = trait.getValue();
    const {appEditorStore, undoManager} = useStore();
    const {isSelectingTarget} = appEditorStore;
    const [, triggerUp] = useState(0);
    const [tempValue, setTempValue] = useState(value);
    const editor = useEditor();
    const up = () => triggerUp((i) => ++i);

    const setValue = (newValue) => {
        const prevValue = trait.getValue();
        trait.setValue(newValue);
        const higherComponent = findParent(trait.component);
        const connectedBoardId = higherComponent.attributes.attributes['data-id'];
        const targetComponent = trait.component;
        let {
            selectorType,
            selector,
            selectorIdx,
            parentSelector,
            parentIdx
        } = appEditorStore.getComponentSelector(targetComponent);
        undoManager.add(new PropertyUpdateStack({
            href: prevValue,
            selectorType, selector, selectorIdx, parentSelector, parentIdx,
            connectedBoardId
        }, {
            href: newValue,
            selectorType,
            selector,
            selectorIdx,
            parentSelector,
            parentIdx,
            connectedBoardId
        }))
    };

    useEffect(() => {
        let offKeyEscape = () => {
        };
        const stop = () => {
            offKeyEscape();
            try {
                editor.stopCommand(CMD_SELECT_TARGET);
            } catch (e) {
                console.log(e);
            }

        };

        if (isSelectingTarget) {
            offKeyEscape = onKeyEscape(stop);
            editor.runCommand(CMD_SELECT_TARGET, {
                onSelect: (cmp) => setValue(`#${cmp.getId()}`),
            });
        }

        return stop;
    }, [isSelectingTarget]);

    return (
        <>
            {/*<LabelField size="s">Href</LabelField>*/}
            <InputField
                className="iframe-src-input-field"
                placeholder="eg. 영상 링크를 입력해 주세요"
                value={tempValue}
                label="Src"
                // onChange={setValue}
                onChangeLive={setTempValue}
                size="s"
                type="url"
            />
            <Button
                type={"fill"}
                size={"s"}
                text={"저장"}
                onClickFunc={() => {
                    setValue(tempValue);
                }}
            />
        </>
    )
});